// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-stuck-claims/app-settings-stuck-claims.less
// module id = 3210
// module chunks = 0